import { useRef, useState } from 'react';

import useOnScrolled from '../../../../hooks/useOnScrolled';
import { OptionsIcon } from '../../../../icons';
import { DropdownListItem, DropdownOption } from '../../../Dropdown';
import Icon from '../../../Icon';
import List from '../../../List';
import { Popover, PopoverTrigger } from '../../../Popover';
import DataTableActionButton from '../DataTableActionButton';

import { OptionsPopoverContent } from './styled';

type Props = {
  options: DropdownOption[];
  onClick: (
    option: DropdownOption,
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) => void;
  maxHeight?: string;
  width?: string;
};

const DataTableCellOptions = ({
  options,
  maxHeight,
  width,
  onClick,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleListItemClick: Props['onClick'] = (option, event) => {
    onClick(option, event);

    if (event.isDefaultPrevented()) {
      return;
    }

    setIsOpen(false);
  };

  const triggerRef = useRef<HTMLButtonElement>(null);

  useOnScrolled(
    triggerRef,
    () => {
      setIsOpen(false);
    },
    { skip: !isOpen },
  );

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <DataTableActionButton
          icon={OptionsIcon}
          label="cell-options"
          ref={triggerRef}
        />
      </PopoverTrigger>
      <OptionsPopoverContent collisionPadding={8} sideOffset={6}>
        <List maxHeight={maxHeight} width={width}>
          {options.map(item => {
            const { key, label, value, isDisabled, icon } = item;

            return (
              <DropdownListItem
                isDisabled={isDisabled}
                key={key || `${label}-${value}`}
                left={typeof icon === 'string' ? <Icon src={icon} /> : icon}
                tabIndex={isOpen ? 0 : -1}
                onClick={event => handleListItemClick(item, event)}>
                {label || value}
              </DropdownListItem>
            );
          })}
        </List>
      </OptionsPopoverContent>
    </Popover>
  );
};

export default DataTableCellOptions;
